module.exports = __webpack_public_path__ + "images/wxwork/arrow-orange@2x-a81ce94cbbd3e4dbb0198552aee7559a.png";